<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-6.col-8.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-sync"
          :text="$t('ui.refresh')"
          type="button"
          @click="getTriggerOpList(true)"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th.sortable(width="10%")
                  span(:title="$t('ui.event_type')") {{ $t('ui.event_type') }}
                th.sortable(width="8%")
                  span(:title="$t('ui.action_type')") {{ $t('ui.action_type') }}
                th(width="7%")
                  span(:title="$t('ui.campaign_id')") {{ $t("ui.campaign_id") }}
                th.text-right(width="7%")
                  span(:title="$t('ui.threshold')") {{ $t('ui.threshold') }}
                th(width="7%")
                  span(:title="$t('ui.reward')") {{ $t("ui.reward") }}
                th.text-center(width="6%")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th.text-center(width="10%" v-if="isEditAccess || isDepositTierAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
            tbody.clusterize-content
              tr(v-if="triggerOpList.length == 0")
                td(colspan="8").text-center
                  span {{ $t('message.no_data_available') }}
              template(v-for="(item, index) in triggerOpList")
                tr(:class="$helpers.rowClassBitPromo(item.status)")
                  td.text-center
                    span(:title="index + 1") {{ index + 1 }}
                  td
                    span(:title="item.event_type") {{ item.event_type }}
                  td
                    span.d-block(:title="item.action_type") {{ item.action_type }}
                    .float-right(v-if="item.action_type == 'CUSTOM_PROMO'")
                      i.fa.fa-lg(:title="$t('ui.detail')" size="sm" @click="onOffDetail(item)" :class="currId == item.event_type ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                  td
                    span(:title="item.campaign_id") {{ item.campaign_id }}
                  td.text-right
                    span.font-weight-bold(:title="$n(item.threshold, 'currency')" :class="$helpers.fontClassName(item.threshold)") {{ $n(item.threshold, 'currency') }}
                  td
                    span(:title="item.reward") {{ item.reward }}
                  td
                    div.d-flex.justify-content-center.align-items-center
                      label.custom-switch
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="!isEditAccess ? null : changedStatus(item, $event)" :disabled="!isEditAccess")
                        span.custom-switch-indicator
                  td.actions.text-center(v-if="isEditAccess || isDepositTierAccess")
                    span.mr-1(v-if="isEditAccess")
                      a.fa.fa-edit.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                    span.mr-1(v-if="isDepositTierAccess && item.event_type == 'PREDICT_CHURN'")
                      a.fa.fa-layer-group.btn.btn-ssm.btn-info(href="javascript:void(0)" @click="onDepositTier(item)" :title="$t('ui.deposit_tier')")
                tr(v-if="isShowDetail == true && currId == item.event_type")
                  td(colspan="14")
                    table.table.table-sm.table-bordered.table-striped.table-hover
                      thead.thead-dark
                        tr
                          th.text-center.sortable(width="10%")
                            span(:title="$t('ui.withhold_bonus')") {{ $t("ui.withhold_bonus") }}
                          th.sortable.text-right(width="10%")
                            span(:title="$t('ui.withhold_amount')") {{ $t("ui.withhold_amt") }}
                          th.sortable.text-right(width="11%")
                            span(:title="$t('ui.max_withdraw_amount')") {{ $t("ui.max_withdraw_amt") }}
                          th.sortable.text-right(width="12%")
                            span(:title="$t('ui.max_withdraw_multiple')") {{ $t("ui.max_withdraw_multiple") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.monday')") {{ $t("ui.short.monday") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.tuesday')") {{ $t("ui.short.tuesday") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.wednesday')") {{ $t("ui.short.wednesday") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.thursday')") {{ $t("ui.short.thursday") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.friday')") {{ $t("ui.short.friday") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.saturday')") {{ $t("ui.short.saturday") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.sunday')") {{ $t("ui.short.sunday") }}
                          th.text-right(width="9%")
                            span(:title="$t('ui.start_date')") {{ $t("ui.start_date") }}
                          th.text-right(width="9%")
                            span(:title="$t('ui.end_date')") {{ $t("ui.end_date") }}
                      tbody.clusterize-content
                        tr
                          td.text-center
                            span
                              i(:class="{'fas fa-check text-info': item.withhold_bonus, 'fas fa-times text-warning': !item.withhold_bonus  }")
                          td.text-right
                            span(:title="$n(item.withhold_amount, 'currency')") {{ $n(item.withhold_amount, 'currency') }}
                          td.text-right
                            span(:title="$n(item.max_withdraw_amount, 'currency')") {{ $n(item.max_withdraw_amount, 'currency') }}
                          td.text-right
                            span(:title="$n(item.max_withdraw_multiple, 'currency')") {{ $n(item.max_withdraw_multiple, 'currency') }}
                          td.text-center
                            span
                              i(:class="{'fas fa-check text-info': item.monday, 'fas fa-times text-warning': !item.monday  }")
                          td.text-center
                            span
                              i(:class="{'fas fa-check text-info': item.tuesday, 'fas fa-times text-warning': !item.tuesday  }")
                          td.text-center
                            span
                              i(:class="{'fas fa-check text-info': item.wednesday, 'fas fa-times text-warning': !item.wednesday  }")
                          td.text-center
                            span
                              i(:class="{'fas fa-check text-info': item.thursday, 'fas fa-times text-warning': !item.thursday  }")
                          td.text-center
                            span
                              i(:class="{'fas fa-check text-info': item.friday, 'fas fa-times text-warning': !item.friday  }")
                          td.text-center
                            span
                              i(:class="{'fas fa-check text-info': item.saturday, 'fas fa-times text-warning': !item.saturday  }")
                          td.text-center
                            span
                              i(:class="{'fas fa-check text-info': item.sunday, 'fas fa-times text-warning': !item.sunday  }")
                          td.text-right
                            span(:title="$moment(item.start_date).format('YYYY-MM-DD') + ', ' + item.start_time") {{ $moment(item.start_date).format('YYYY-MM-DD') }}
                            br
                            span(:title="$moment(item.start_date).format('YYYY-MM-DD') + ', ' + item.start_time") {{ item.start_time }}
                          td.text-right
                            span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ $moment(item.end_date).format("YYYY-MM-DD") }}
                            br
                            span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ item.end_time }}
                    table.table.table-sm.table-bordered.table-striped.table-hover
                      thead.thead-dark
                        tr
                          th(width="25%")
                            span(:title="$t('ui.provider_list')") {{ $t("ui.provider_list") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.bonus_rate_1')") {{ $t("ui.bonus_rate_1") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.bonus_rate_2')") {{ $t("ui.bonus_rate_2") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.bonus_rate_3')") {{ $t("ui.bonus_rate_3") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.bonus_rate_4')") {{ $t("ui.bonus_rate_4") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.bonus_rate_5')") {{ $t("ui.bonus_rate_5") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.bonus_rate_6')") {{ $t("ui.bonus_rate_6") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.bonus_rate_7')") {{ $t("ui.bonus_rate_7") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.bonus_rate_8')") {{ $t("ui.bonus_rate_8") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.bonus_rate_9')") {{ $t("ui.bonus_rate_9") }}
                          th.text-center(width="6%")
                            span(:title="$t('ui.bonus_rate_10')") {{ $t("ui.bonus_rate_10") }}
                      tbody.clusterize-content
                        tr
                          td
                            template(v-if="item.provider_list")
                              a.float-right.pointer(v-if="item.provider_list.split(',').map(p => p.trim()).length > 5" @click="showPAll = !showPAll")
                                i.fa(:class="showPAll ? 'fa-minus' : 'fa-plus'")
                              b-badge.mr-1.mb-1(
                                v-for="(provider, i) in (showPAll ? item.provider_list.split(',').map(p => p.trim()) : item.provider_list.split(',').map(p => p.trim()).slice(0, 5))"
                                :key="provider"
                                variant="secondary"
                              )
                                | {{ provider }}
                            template(v-else)
                              b-badge {{ $t('ui.all') }}
                          td.text-center
                            span(:title="item.bonus_rate_1") {{ item.bonus_rate_1 }}
                          td.text-center
                            span(:title="item.bonus_rate_2") {{ item.bonus_rate_2 }}
                          td.text-center
                            span(:title="item.bonus_rate_3") {{ item.bonus_rate_3 }}
                          td.text-center
                            span(:title="item.bonus_rate_4") {{ item.bonus_rate_4 }}
                          td.text-center
                            span(:title="item.bonus_rate_5") {{ item.bonus_rate_5 }}
                          td.text-center
                            span(:title="item.bonus_rate_6") {{ item.bonus_rate_6 }}
                          td.text-center
                            span(:title="item.bonus_rate_7") {{ item.bonus_rate_7 }}
                          td.text-center
                            span(:title="item.bonus_rate_8") {{ item.bonus_rate_8 }}
                          td.text-center
                            span(:title="item.bonus_rate_9") {{ item.bonus_rate_9 }}
                          td.text-center
                            span(:title="item.bonus_rate_10") {{ item.bonus_rate_10 }}

    edittrigger(ref="edittrigger" :item="editSelectedTrigger" @clicked="afterEdit" @failed="handleFailed")
    edittriggerstatus(ref="edittriggerstatus" :item="editSelectedTrigger" @clicked="afterEditStatus" @failed="handleFailed" @cancelStatus="getTriggerOpList()")
    deposittier(ref="deposittier" :operatorID="operatorID" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import edittrigger from "@/components/promo/editTrigger.vue";
import edittriggerstatus from "@/components/promo/editTriggerStatus.vue";
import deposittier from "@/components/promo/depositTier/depositTier.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    edittrigger,
    edittriggerstatus,
    deposittier
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    triggerOpList: [],
    currId: null,
    isShowDetail: false,
    editSelectedTrigger: null,
    selectedPromo: null,
    showPAll: false
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_trigger");
    },
    isDepositTierAccess() {
      return this.$helpers.showActionButton("deposittier");
    },
  },
  mounted: function() {  },
  methods: {
    onDepositTier(e) {
      this.$refs.deposittier.$refs.depositTier.show();
    },
    onEdit(e) {
      this.editSelectedTrigger = e;
      this.$refs.edittrigger.$refs.editTrigger.show();
    },
    afterEdit: function() {
      this.getTriggerOpList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_trigger"), this.$t("message.success"), "success");
    },
    afterEditStatus: function() {
      this.getTriggerOpList();
      this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
    },
    refresh() {
      this.getTriggerOpList(true);
    },
    onOffDetail(item) {
      this.showPAll = false
      if (this.isShowDetail == true) {
        if (this.currId == item.event_type) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = false;
          this.currId = null;
          this.isShowDetail = true;
          this.currId = item.event_type;
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.event_type;
      }
    },
    getTriggerOpList: function(isSearch) {
      this.isShowDetail = false;
      this.showPAll = false
      this.currId = null;
      let url = config.triggerOpListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.triggerOpList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedStatus: function(item, eventStatus) {
      if(item.status == true) {
        this.editSelectedTrigger = item;
        this.$refs.edittriggerstatus.$refs.editTriggerStatus.show();
      }
      else {
        this.$helpers
          .alert({
            title: this.$t("ui.status"),
            text: this.$t("message.change_trigger_status_confirm", { name: item.event_type }),
            type: "question",
            showCancelButton: true
          })
          .then(result => {
            if (result.value) {
              this.confirmStatus(item, eventStatus.srcElement.checked);
            } else {
              eventStatus.srcElement.checked = !item.status;
              item.status = !item.status;
            }
          });
      }
    },
    confirmStatus: function(item, status) {
      let url = config.triggerOpStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        event_type: item.event_type,
        action_type: item.action_type,
        new_status: false
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getTriggerOpList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getTriggerOpList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
      this.getTriggerOpList();
    }
  }
};
</script>